export function getExperience(startDateStr) {
  const start = new Date(startDateStr);
  const now = new Date();
  const years = (now - start) / (1000 * 60 * 60 * 24 * 365.25);
  return (Math.floor(years * 10) / 10).toFixed(1);
}
